import { onBeforeUnmount, onMounted, unref, watch } from 'vue'
import {
  cancelScheduledSwiperInit,
  destroySwiperInRoot,
  scheduleSwiperInit
} from '../lib/swiperInit.js'

/**
 * Gleiches Lifecycle wie Gallery/Impressionen: scheduleInit nach mount + watch.
 */
export function useJQuerySwiper({
  rootRef,
  canInit,
  buildOptions,
  onDestroy
}) {
  const scheduleInit = () => {
    const root = unref(rootRef)
    if (!root || (canInit && !canInit())) return

    scheduleSwiperInit(root, buildOptions ? buildOptions(root) : {})
  }

  onMounted(() => {
    setTimeout(scheduleInit, 100)
  })

  onBeforeUnmount(() => {
    const root = unref(rootRef)
    cancelScheduledSwiperInit(root)
    destroySwiperInRoot(root, onDestroy)
  })

  return { scheduleInit }
}

export function useJQuerySwiperWatch(source, scheduleInit, options = {}) {
  watch(source, () => {
    setTimeout(scheduleInit, 100)
  }, { deep: true, immediate: true, ...options })
}
